import { PublicCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import { FC } from 'react';
import { useProfileContext } from '../../Contexts/ProfileContext';
import AboutDesktop from './AboutDesktop';
import AboutMobile from './AboutMobile';

type Props = {
  isMobileView?: boolean;
  certifications: PublicCertification[];
  onShowLess?: () => void;
};

const About: FC<Props> = ({ isMobileView, certifications, onShowLess }) => {
  const {
    partnerProfile: { professionalInformation, platforms },
  } = useProfileContext();
  const about = professionalInformation?.about;

  return isMobileView ? (
    <AboutMobile
      about={about}
      platforms={platforms}
      certifications={certifications}
      onShowLess={onShowLess}
    />
  ) : (
    <AboutDesktop
      about={about}
      platforms={platforms}
      certifications={certifications}
      onShowLess={onShowLess}
    />
  );
};

export default About;
